import { Iata } from '@reward-platform/platform-config'

/**
 * Household redemption is always available for BA and for IB only behind the
 * `iberia-hh-enabled` feature flag. Everywhere else orders are validated against
 * and paid from the personal Avios balance.
 */
export const isHouseholdRedemptionEnabledForOpCo = (
  opCo: Iata,
  isIberiaHouseholdEnabled = false
): boolean => opCo === 'BA' || (opCo === 'IB' && isIberiaHouseholdEnabled)
